import React from 'react';
import { compose } from 'recompose';

import {
  Checkbox,
  Divider,
  FormControlLabel,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import SizeEditor from '../objectEditors/SizeEditor';
import ColorEditor from '../objectEditors/ColorEditor';
import { areEqual } from '../../../../utilities';

function createWeightUnits(value) {
  return Math.round(value / 10) + '%';
}

function createSizeUnits(value) {
  return Math.round(value * 5) + '%';
}

const fontSizeCustomProps = {
  min: 10,
  max: 40,
  step: 1,
  createCustomUnits: createSizeUnits,
}

const fontWeightCustomProps = {
  min: 100,
  max: 1000,
  step: 100,
  createCustomUnits: createWeightUnits,
}

function FontAutoScalingController(props) {
  const {
    isVisible,
    handleChange,
    label,
    disabled = false,
  } = props;

  function onChange() {
    handleChange(!isVisible);
  }

  return (
    <FormControlLabel
      control={
        <Checkbox
          color="primary"
          onChange={onChange}
          checked={isVisible}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
}

function LabelDetail(props) {
  const {
    classes,
    handleFontSizeChange,
    handleFontWeightChange,
    handleFontColorChange,
    handleLabelBackgroundColorChange,
    fontSize,
    fontWeight,
    fontColor,
    labelBackgroundColor,
    isFontDependsFromZoom,
    setIsFontDependsFromZoom,
    shouldDisableEditors
  } = props;

  return (
    <>
      <div className={classes.editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={classes.editorTitle}
        >
          Font Size
        </Typography>
        <SizeEditor
          value={fontSize}
          onChange={handleFontSizeChange}
          disabled={shouldDisableEditors} 
          { ...fontSizeCustomProps }
        />
        <FontAutoScalingController
          label="Depends On Zoom"
          isVisible={isFontDependsFromZoom}
          handleChange={setIsFontDependsFromZoom}
          title="Font Auto-Scaling"
          classes={classes}
          disabled={shouldDisableEditors} 
        />
      </div>
      <Divider />
      <div className={classes.editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={classes.editorTitle}
        >
          Font Weight
        </Typography>
        <SizeEditor
          value={fontWeight}
          onChange={handleFontWeightChange}
          disabled={shouldDisableEditors} 
          { ...fontWeightCustomProps }
        />
      </div>
      <Divider />
      <div className={classes.editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={classes.editorTitle}
        >
          Font Color
        </Typography>
        <ColorEditor style={{ marginTop: 6 }} value={fontColor} onChange={handleFontColorChange} disabled={shouldDisableEditors} />
      </div>
      <Divider />
      <div className={classes.editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={classes.editorTitle}
        >
          Background Color
        </Typography>
        <ColorEditor style={{ marginTop: 6 }} value={labelBackgroundColor} onChange={handleLabelBackgroundColorChange} disabled={shouldDisableEditors}/>
      </div>
      <Divider />
    </>
  );
}

const styles = () => ({
  editorContainer: {
    padding: '0.5rem 1.5rem 1rem'
  },
  editorTitle: {
    marginLeft: -8,
    marginBottom: 4,
    fontSize: '1rem'
  }
});

export default compose(withStyles(styles))(React.memo(LabelDetail, areEqual));
